<!-- Proforma Ship Request Modal -->
<div class="modal fade" id="kt_modal_proforma_ship_request" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold mb-0">Ship Request</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form [formGroup]="shipRequestForm" (ngSubmit)="onSubmit()">

          <!-- Section Heading -->
          <h5 class="fw-semibold mb-4">Consignee Details</h5>

          <!-- Consignee Name -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Consignee Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="CONSIGNEE NAME"
                formControlName="consigneeName"
                [class.is-invalid]="isFieldInvalid('consigneeName')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('consigneeName')">
                Consignee name is required
              </div>
            </div>
          </div>

          <!-- Address -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Address</label>
              <input
                type="text"
                class="form-control"
                placeholder="ADDRESS"
                formControlName="address"
                [class.is-invalid]="isFieldInvalid('address')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('address')">
                Address is required
              </div>
            </div>
          </div>

          <!-- Email Address -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Email Address</label>
              <input
                type="email"
                class="form-control"
                placeholder="email@example.com"
                formControlName="emailAddress"
                [class.is-invalid]="isFieldInvalid('emailAddress')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('emailAddress')">
                <span *ngIf="shipRequestForm.get('emailAddress')?.errors?.['required']">Email address is required</span>
                <span *ngIf="shipRequestForm.get('emailAddress')?.errors?.['email']">Valid email address is required</span>
              </div>
            </div>
          </div>

          <!-- Phone Number -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Phone Number</label>
              <input
                type="text"
                class="form-control"
                placeholder="PHONE NUMBER"
                formControlName="phoneNumber"
                [class.is-invalid]="isFieldInvalid('phoneNumber')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('phoneNumber')">
                Phone number is required
              </div>
            </div>
          </div>

          <hr class="my-4">

          <!-- Confirmation Checkbox -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="detailsConfirmed"
                  formControlName="detailsConfirmed"
                  (change)="onDetailsConfirmedChange()">
                <label class="form-check-label fw-semibold" for="detailsConfirmed">
                  I confirm that all the above consignee details are correct
                </label>
              </div>
            </div>
          </div>

          <!-- Agent Notes -->
          <div class="row mb-6">
            <div class="col-12">
              <label class="form-label fw-semibold">
                Agent Notes
                <span class="text-muted ms-1" *ngIf="!shipRequestForm.get('detailsConfirmed')?.value">(Required)</span>
                <span class="text-muted ms-1" *ngIf="shipRequestForm.get('detailsConfirmed')?.value">(Optional)</span>
              </label>
              <textarea
                class="form-control"
                rows="3"
                placeholder="Enter agent notes"
                formControlName="agentNotes"
                [class.is-invalid]="isFieldInvalid('agentNotes')"></textarea>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('agentNotes')">
                Agent notes are required when consignee details are not confirmed
              </div>
            </div>
          </div>

          <!-- Error Alert -->
          <div class="alert alert-danger d-flex align-items-center mb-4" *ngIf="submitError">
            <i class="ki-duotone ki-shield-cross fs-2hx me-3 text-danger">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            <div>{{ submitError }}</div>
          </div>

          <!-- Submit Button -->
          <div class="row">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-primary px-8" [disabled]="isSubmitDisabled()">
                <span *ngIf="!isLoading">Submit</span>
                <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Submitting...
                </span>
              </button>
            </div>
          </div>

        </form>
      </div>

    </div>
  </div>
</div>
